
import { Client } from './clientTypes';

export const financeClients: Client[] = [
  { 
    id: 1, 
    name: "COOPENAE", 
    logoPath: "/lovable-uploads/3ae79aeb-dd8a-4759-b746-14a18cbf48db.png",
    altText: "Logo de COOPENAE"
  },
  { 
    id: 10, 
    name: "Banco General", 
    logoPath: "/lovable-uploads/bad8d48c-2e1a-4e96-b7d3-70475dc2b2ab.png",
    altText: "Logo de Banco General"
  },
  { 
    id: 14, 
    name: "Coopecaja", 
    logoPath: "/lovable-uploads/1658d476-dc41-44be-bc13-19909640f3be.png",
    altText: "Logo de Coopecaja"
  },
  { 
    id: 15, 
    name: "Crowe", 
    logoPath: "/lovable-uploads/3862c80e-ce04-45bc-9957-c8d6ce7bf928.png",
    altText: "Logo de Crowe"
  },
  { 
    id: 25, 
    name: "EY", 
    logoPath: "/lovable-uploads/ab71b9ea-6715-4bef-a00a-7109832d48fb.png",
    altText: "Logo de EY"
  },
];
